import React from "react";
import noMarketsFoundIllustration from "../assets/no-found.png";

const NoMarketsFound: React.FC = () => {
  return (
    <div className="empty-markets-state">
      <img
        src={noMarketsFoundIllustration}
        alt="No prediction markets found"
        className="empty-markets-state__image"
      />
      <p className="empty-markets-state__text">No markets found</p>
    </div>
  );
};

export default NoMarketsFound;
